import React from "react";
import { Link } from "react-router-dom";
import { routes } from "../../store/routes";

function RegisterMessageLogin({ onLogin }) {
    const linkStyle = {
        color: "var(--primary)",
        textDecoration: "none",
        fontWeight: "bold",
        background: "none",
        border: "none",
        padding: 0,
        cursor: "pointer",
        fontSize: "0.9rem",
    };

    return (
        <div style={{
            textAlign: "center",
            paddingTop: "1.5rem",
            marginTop: "1.5rem",
            borderTop: "1px solid rgba(214, 12, 140, 0.1)",
        }}>
            <p style={{
                margin: 0,
                color: "var(--dark)",
                fontSize: "0.9rem",
            }}>
                Už máš konto?{" "}
                {onLogin ? (
                    <button type="button" onClick={onLogin} style={linkStyle}>
                        Prihlás sa tu
                    </button>
                ) : (
                    <Link to={routes.LOGIN} style={linkStyle}>
                        Prihlás sa tu
                    </Link>
                )}
            </p>
        </div>
    );
}

export default RegisterMessageLogin;
